import { render, staticRenderFns } from "./DetailedCorrectionDialog.vue?vue&type=template&id=2e9dfd3c&"
import script from "./DetailedCorrectionDialog.vue?vue&type=script&lang=js&"
export * from "./DetailedCorrectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports